import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Link } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

import { getUserTokenFromLocalStorage } from '@utils/localStorage';

import NutramegLoginImage from '@assets/LoginPage/nutrameg-login.png';
import ArtLeftBottomImage from '@assets/LoginPage/left-bottom.png';
import ArtTopRightImage from '@assets/LoginPage/right-top.png';

import s from './LoginPage.module.css';

function LoginPage() {
  const navigate = useNavigate();
  const redirectUrl = `${window.location.origin}/dashboard/charger-flows`;
  const loginUrl = `${import.meta.env.VITE_API_URL}/admin/auth/google?redirect=${redirectUrl}`;

  useEffect(() => {
    const userToken = getUserTokenFromLocalStorage();
    if (userToken) {
      navigate('/dashboard/charger-flows', { replace: true });
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={s.wrapper}>
      <img src={ArtLeftBottomImage} alt="Decorative Art Left" className={s.artLeftBottom} />
      <img src={ArtTopRightImage} alt="Decorative Art Right" className={s.artRightTop} />
      <div className={s.container}>
        <img src={NutramegLoginImage} alt="Nutrameg Logo" className={s.logo} />
        <h1 className={`heading ${s.loginTitle}`}>Payments System</h1>
        <Link href={loginUrl} className={s.loginButton}>
          <GoogleIcon color="secondary" />
          <p className={s.loginButtonText}>Login</p>
        </Link>
      </div>
    </div>
  );
}

export default LoginPage;
